import { Box } from '@mui/material';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import classes from './DropdownMenu.module.scss';
const DropdownMenu = ({
  button,
  menuItems
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <Box className={classes['dropdown']} ref={dropdownRef} data-sentry-element="Box" data-sentry-component="DropdownMenu" data-sentry-source-file="DropdownMenu.tsx">
			<Box onClick={toggleMenu} role="button" aria-haspopup="true" aria-expanded={isOpen} data-sentry-element="Box" data-sentry-source-file="DropdownMenu.tsx">
				{button}
			</Box>
			{isOpen && <ul className={classes['menu']} role="menu" aria-orientation="vertical">
					{menuItems.map((item, index) => <li key={index} className={classes['menuItem']} role="menuitem">
							<Link href={item.link} aria-label={`Go to ${item.text} page`}>
								{item.text}
							</Link>
						</li>)}
				</ul>}
		</Box>;
};
export default DropdownMenu;